import { useNavigate } from 'react-router-dom'

import styles from './index.module.scss'

const TransactionHistoryItem = ({ item, onClick }) => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (onClick) {
      onClick(item)
    } else if (item.route) {
      navigate(item.route)
    }
  }

  // Get icon based on transaction type
  const getTransactionIcon = () => {
    if (item.assets?.leadingIcon) {
      return item.assets.leadingIcon
    }
    // Default icons based on title
    if (item.title?.toLowerCase().includes('repayment')) {
      return 'document' // You can change this to the actual icon name
    }
    if (item.title?.toLowerCase().includes('withdrawal')) {
      return 'money' // You can change this to the actual icon name
    }
    return 'document'
  }

  return (
    <div className='ew-d-flex ew-gap-10' onClick={handleClick}>
      {/* Leading Icon */}
      <div
        className={`${styles.iconContainer} ew-border ew-rounded-md ew-p-8 ew-d-flex ew-align-items-center ew-justify-content-center`}>
        <img alt='List Icon' height={24} src={getTransactionIcon()} width={24} />
      </div>

      {/* Content */}
      <div className='ew-d-flex ew-flex-column ew-flex-grow-1'>
        <div className='ew-typography-small ew-fw-semi-bold ew-color-primary'>{item.title}</div>
        <div className='ew-typography-small ew-fw-regular ew-color-secondary'>
          {item.description}
        </div>
      </div>

      {/* Amount */}
      <div className='ew-d-flex ew-flex-column ew-align-items-end'>
        <div className='ew-fw-semi-bold ew-color-primary'>{item.subtitle}</div>
        {item.meta?.label ? (
          <div
            className='ew-mt-2 ew-typography-tiny ew-fw-semi-bold'
            style={{ color: item.meta.color || '#10B981' }}>
            {item.meta.label}
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default TransactionHistoryItem
